import React, { memo, useCallback, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";

import Icon from "../../assets/icons/Icon";
import { uiActions } from "../../store/ui/ui-slice";
import { useManageRole } from "../Hooks";
import logo from "/assets/images/logo.png";

const Sidebar = () => {
  const dispatch = useDispatch();
  const {
    isDashboard,
    isUpload,
    isPaymentGateway,
    isSport,
    isTournament,
    isMatch,
    isMarket,
    isFancy,
    isLine,
    isBookmaker,
    isImport,
    isOpenGame,
    isUser,
    isRole,
    isGameSetting,
    isUserSetting,
    isWhiteLabelSetting,
    isLiveTv,
    isCommentary,
  } = useManageRole();

  const [collapsed, setCollapsed] = useState(false);
  const [activeSections, setActiveSections] = useState({
    Games: false,
    reports: false,
    roleManagement: false,
    globalSettings: false,
    configuration: false,
    management: false,
  });

  const toggleSection = useCallback(
    (section) => {
      dispatch(uiActions.setHeading(section));
      setActiveSections((prev) => {
        const isCurrentlyActive = prev[section];
        const newSections = Object.keys(prev).reduce((acc, key) => {
          acc[key] = key === section ? !isCurrentlyActive : false;
          return acc;
        }, {});
        return newSections;
      });
    },
    [dispatch],
  );

  const handleNavLinkClick = () => {
    toggleSidebarSize(true);
  };

  const toggleSidebarSize = useCallback((isTriggeredByNavLink = false) => {
    const body = document.body;
    const isMobileView = window.innerWidth < 968;
    const currentSize = body.getAttribute("data-sidebar-size");

    // 📱 Mobile behavior
    if (isMobileView) {
      if (isTriggeredByNavLink) {
        body.setAttribute("data-sidebar-size", "collapsed");
        setCollapsed(true);
      } else {
        const newSize = currentSize === "default" ? "collapsed" : "default";
        body.setAttribute("data-sidebar-size", newSize);
        setCollapsed(newSize === "collapsed");
      }
      return;
    }

    //  Desktop behavior
    if (isTriggeredByNavLink) {
      body.setAttribute("data-sidebar-size", "default");
      setCollapsed(false);
      return;
    }
    const newSize = currentSize === "default" ? "collapsed" : "default";
    body.setAttribute("data-sidebar-size", newSize);
    setCollapsed(newSize === "collapsed");
  }, []);

  return (
    <>
      <aside className="sidebar-cover">
        <div className="aside-logo">
          <Link to="/" className="logo_box">
            <img alt="Logo" src={logo} className="logo_img" />
          </Link>
          <button
            className="aside-toggle"
            onClick={() => toggleSidebarSize(false)}
            aria-label="Toggle sidebar"
          >
            <span className={collapsed ? "" : "rotate-180"}>
              <Icon name="MdOutlineMenuOpen" />
            </span>
          </button>
        </div>

        <div className="aside-menu">
          <div className="startbar-menu">
            <div
              className="startbar-collapse"
              id="startbarCollapse"
              data-simplebar
            >
              <div className="d-flex align-items-start flex-column w-100">
                <ul className="navbar-nav mb-auto w-100">
                  <li className="menu-label mt-2">
                    <span>Master</span>
                  </li>

                  {/* Dashboard */}
                  <li className="nav-item">
                    <NavLink
                      className={({ isActive }) =>
                        `nav-link ${isActive ? "active" : ""}`
                      }
                      to="/"
                      onClick={() => {
                        handleNavLinkClick();
                        toggleSection("Dashboard");
                      }}
                    >
                      <Icon
                        name="MdDashboard"
                        className="iconoir-report-columns menu-icon"
                      />
                      <span>Dashboard</span>
                    </NavLink>
                  </li>

                  {/* Upload */}
                  {isUpload && (
                    <li className="nav-item">
                      <NavLink
                        className={({ isActive }) =>
                          `nav-link ${isActive ? "active" : ""}`
                        }
                        to="/commentary/image-upload"
                        onClick={() => {
                          handleNavLinkClick();
                          toggleSection("Upload");
                        }}
                      >
                        <Icon
                          name="FaUpload"
                          className="iconoir-report-columns menu-icon"
                        />
                        <span>Upload</span>
                      </NavLink>
                    </li>
                  )}

                  {/* Payment Gateway */}
                  {isPaymentGateway && (
                    <li className="nav-item">
                      <NavLink
                        className={({ isActive }) =>
                          `nav-link ${isActive ? "active" : ""}`
                        }
                        to="/commentary/payment-gateway"
                        onClick={() => {
                          handleNavLinkClick();
                          toggleSection("Payment Gateway");
                        }}
                      >
                        <Icon
                          name="MdOutlinePayments"
                          className="iconoir-report-columns menu-icon"
                        />
                        <span>Payment Gateway</span>
                      </NavLink>
                    </li>
                  )}

                  {/* Games Section */}

                  <li className="nav-item">
                    <Link
                      className={`nav-link arro_icon ${activeSections.Games ? "active" : ""}`}
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleSection("Games");
                      }}
                      aria-expanded={activeSections.Games}
                    >
                      <Icon
                        name="FaGamepad"
                        className="iconoir-task-list menu-icon"
                      />
                      <span>Games</span>
                    </Link>
                    <div
                      className={`collapse ${activeSections.Games ? "show" : ""}`}
                    >
                      <ul className="nav flex-column">
                        <li className="nav-item">
                          <NavLink
                            className={({ isActive }) =>
                              `nav-link ${isActive ? "active" : ""}`
                            }
                            to="/eventmaster/sport"
                            onClick={handleNavLinkClick}
                          >
                            Sports
                          </NavLink>
                        </li>
                        {/* {isTournament && (
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              to="/eventmaster/tournaments"
                              onClick={handleNavLinkClick}
                            >
                              Tournaments
                            </NavLink>
                          </li>
                        )}
                        {isMatch && (
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              to="/eventmaster/matches"
                              onClick={handleNavLinkClick}
                            >
                              Matches
                            </NavLink>
                          </li>
                        )}
                        {isMarket && (
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              to="/eventmaster/market"
                              onClick={handleNavLinkClick}
                            >
                              Markets
                            </NavLink>
                          </li>
                        )}
                        {isFancy && (
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              to="/eventmaster/fancy"
                              onClick={handleNavLinkClick}
                            >
                              Fancy
                            </NavLink>
                          </li>
                        )}
                        {isLine && (
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              to="/eventmaster/line"
                              onClick={handleNavLinkClick}
                            >
                              Line
                            </NavLink>
                          </li>
                        )}
                        {isBookmaker && (
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              to="/eventmaster/bookmaker"
                              onClick={handleNavLinkClick}
                            >
                              Bookmaker
                            </NavLink>
                          </li>
                        )}
                        {isFancy && (
                          <>
                            <li className="nav-item">
                              <NavLink
                                className={({ isActive }) =>
                                  `nav-link ${isActive ? "active" : ""}`
                                }
                                to="/eventmaster/ImportRadheFancy"
                                onClick={handleNavLinkClick}
                              >
                                Import Radhe Fancy
                              </NavLink>
                            </li>
                            <li className="nav-item">
                              <NavLink
                                className={({ isActive }) =>
                                  `nav-link ${isActive ? "active" : ""}`
                                }
                                to="/eventmaster/ImportIndiaFancy"
                                onClick={handleNavLinkClick}
                              >
                                Import India Fancy
                              </NavLink>
                            </li>
                          </>
                        )} */}
                      </ul>
                    </div>
                  </li>

                  {/* Reports Section */}
                  {isOpenGame && (
                    <li className="nav-item">
                      <Link
                        className={`nav-link arro_icon ${activeSections.reports ? "active" : ""}`}
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleSection("reports");
                        }}
                        aria-expanded={activeSections.reports}
                      >
                        <Icon
                          name="FaList"
                          className="iconoir-task-list menu-icon"
                        />
                        <span>Reports</span>
                      </Link>
                      <div
                        className={`collapse ${activeSections.reports ? "show" : ""}`}
                      >
                        <ul className="nav flex-column">
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              onClick={handleNavLinkClick}
                              to="/reports/openmarket"
                            >
                              Open Market
                            </NavLink>
                          </li>
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              onClick={handleNavLinkClick}
                              to="/reports/settledmarket"
                            >
                              Settle Market
                            </NavLink>
                          </li>
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              onClick={handleNavLinkClick}
                              to="/reports/cancelmarket"
                            >
                              Cancel Market
                            </NavLink>
                          </li>
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              onClick={handleNavLinkClick}
                              to="/reports/casinomarket"
                            >
                              Casino Market
                            </NavLink>
                          </li>
                        </ul>
                      </div>
                    </li>
                  )}

                  {/* Role Management Section */}
                  {(isRole || isUser) && (
                    <li className="nav-item">
                      <Link
                        className={`nav-link arro_icon ${activeSections.roleManagement ? "active" : ""}`}
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleSection("roleManagement");
                        }}
                        aria-expanded={activeSections.roleManagement}
                      >
                        <Icon
                          name="MdManageAccounts"
                          className="iconoir-task-list menu-icon"
                        />
                        <span>Role Management</span>
                      </Link>
                      <div
                        className={`collapse ${activeSections.roleManagement ? "show" : ""}`}
                      >
                        <ul className="nav flex-column">
                          {isUser && (
                            <li className="nav-item">
                              <NavLink
                                className={({ isActive }) =>
                                  `nav-link ${isActive ? "active" : ""}`
                                }
                                onClick={handleNavLinkClick}
                                to="/rolemanager/manageusers"
                              >
                                Manage Users
                              </NavLink>
                            </li>
                          )}
                          {isRole && (
                            <>
                              <li className="nav-item">
                                <NavLink
                                  className={({ isActive }) =>
                                    `nav-link ${isActive ? "active" : ""}`
                                  }
                                  onClick={handleNavLinkClick}
                                  to="/rolemanager/roles"
                                >
                                  Roles
                                </NavLink>
                              </li>
                              <li className="nav-item">
                                <NavLink
                                  className={({ isActive }) =>
                                    `nav-link ${isActive ? "active" : ""}`
                                  }
                                  onClick={handleNavLinkClick}
                                  to="/rolemanager/moduleaccess"
                                >
                                  Module Access
                                </NavLink>
                              </li>
                            </>
                          )}
                        </ul>
                      </div>
                    </li>
                  )}

                  {/* Global Settings Section */}
                  {(isGameSetting || isUserSetting || isWhiteLabelSetting) && (
                    <li className="nav-item">
                      <Link
                        className={`nav-link arro_icon ${activeSections.globalSettings ? "active" : ""}`}
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleSection("globalSettings");
                        }}
                        aria-expanded={activeSections.globalSettings}
                      >
                        <Icon
                          name="MdSettings"
                          className="iconoir-task-list menu-icon"
                        />
                        <span>Global Settings</span>
                      </Link>
                      <div
                        className={`collapse ${activeSections.globalSettings ? "show" : ""}`}
                      >
                        <ul className="nav flex-column">
                          {isGameSetting && (
                            <li className="nav-item">
                              <NavLink
                                className={({ isActive }) =>
                                  `nav-link ${isActive ? "active" : ""}`
                                }
                                onClick={handleNavLinkClick}
                                to="/globalsettings/gamesetting"
                              >
                                Game Settings
                              </NavLink>
                            </li>
                          )}
                          {isUserSetting && (
                            <li className="nav-item">
                              <NavLink
                                className={({ isActive }) =>
                                  `nav-link ${isActive ? "active" : ""}`
                                }
                                onClick={handleNavLinkClick}
                                to="/globalsettings/usersetting"
                              >
                                User Settings
                              </NavLink>
                            </li>
                          )}
                          {isWhiteLabelSetting && (
                            <li className="nav-item">
                              <NavLink
                                className={({ isActive }) =>
                                  `nav-link ${isActive ? "active" : ""}`
                                }
                                onClick={handleNavLinkClick}
                                to="/globalsettings/whitelabelsetting"
                              >
                                WhiteLabel Settings
                              </NavLink>
                            </li>
                          )}
                        </ul>
                      </div>
                    </li>
                  )}

                  {/* Configuration Section */}
                  {
                    // (isImport ||
                    //   isLiveTv ||
                    //   isCommentary ||
                    //   isWhiteLabelSetting) &&
                    <li className="nav-item">
                      <Link
                        className={`nav-link arro_icon ${activeSections.configuration ? "active" : ""}`}
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleSection("configuration");
                        }}
                        aria-expanded={activeSections.configuration}
                      >
                        <Icon
                          name="MdSettingsSuggest"
                          className="iconoir-task-list menu-icon"
                        />
                        <span>Configuration</span>
                      </Link>
                      <div
                        className={`collapse ${activeSections.configuration ? "show" : ""}`}
                      >
                        <ul className="nav flex-column">
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              onClick={handleNavLinkClick}
                              to="/config/reactions"
                            >
                              Reactions
                            </NavLink>
                          </li>
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              onClick={handleNavLinkClick}
                              to="/config/reopencancellist"
                            >
                              Re-Open/Cancel List
                            </NavLink>
                          </li>
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              onClick={handleNavLinkClick}
                              to="/config/matchresult"
                            >
                              Match Result
                            </NavLink>
                          </li>
                          {isLiveTv && (
                            <li className="nav-item">
                              <NavLink
                                className={({ isActive }) =>
                                  `nav-link ${isActive ? "active" : ""}`
                                }
                                onClick={handleNavLinkClick}
                                to="/config/livetv"
                              >
                                Live TV
                              </NavLink>
                            </li>
                          )}
                          {
                            <>
                              <li className="nav-item">
                                <NavLink
                                  className={({ isActive }) =>
                                    `nav-link ${isActive ? "active" : ""}`
                                  }
                                  onClick={handleNavLinkClick}
                                  to="/config/import"
                                >
                                  Import
                                </NavLink>
                              </li>
                              {/* <li className="nav-item">
                                <NavLink
                                  className={({ isActive }) =>
                                    `nav-link ${isActive ? "active" : ""}`
                                  }
                                  onClick={handleNavLinkClick}
                                  to="/config/importdream"
                                >
                                  Import Dream
                                </NavLink>
                              </li> */}
                            </>
                          }
                          {isWhiteLabelSetting && (
                            <li className="nav-item">
                              <NavLink
                                className={({ isActive }) =>
                                  `nav-link ${isActive ? "active" : ""}`
                                }
                                onClick={handleNavLinkClick}
                                to="/config/apisettings"
                              >
                                Api Settings
                              </NavLink>
                            </li>
                          )}
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              onClick={handleNavLinkClick}
                              to="/config/chipssettings"
                            >
                              Chips Settings
                            </NavLink>
                          </li>
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              onClick={handleNavLinkClick}
                              to="/config/rulessettings"
                            >
                              Rules Settings
                            </NavLink>
                          </li>
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active" : ""}`
                              }
                              onClick={handleNavLinkClick}
                              to="/config/welcomemsg"
                            >
                              Welcome Message
                            </NavLink>
                          </li>
                        </ul>
                      </div>
                    </li>
                  }
                  <li className="nav-item">
                    <Link
                      className={`nav-link arro_icon ${activeSections.management ? "active" : ""}`}
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleSection("management");
                      }}
                      aria-expanded={activeSections.management}
                    >
                      <Icon
                        name="MdSettingsSuggest"
                        className="iconoir-task-list menu-icon"
                      />
                      <span>Management</span>
                    </Link>
                    <div
                      className={`collapse ${activeSections.management ? "show" : ""}`}
                    >
                      <ul className="nav flex-column">
                        <li className="nav-item">
                          <NavLink
                            className={({ isActive }) =>
                              `nav-link ${isActive ? "active" : ""}`
                            }
                            onClick={handleNavLinkClick}
                            to="/config/permission"
                          >
                            Permission
                          </NavLink>
                        </li>
                        <li className="nav-item">
                          <NavLink
                            className={({ isActive }) =>
                              `nav-link ${isActive ? "active" : ""}`
                            }
                            onClick={handleNavLinkClick}
                            to="/config/form"
                          >
                            Form
                          </NavLink>
                        </li>
                        <li className="nav-item">
                          <NavLink
                            className={({ isActive }) =>
                              `nav-link ${isActive ? "active" : ""}`
                            }
                            onClick={handleNavLinkClick}
                            to="/config/roles"
                          >
                            Roles
                          </NavLink>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </aside>
      <div onClick={() => setCollapsed(true)} className="sidebarBg_color"></div>
    </>
  );
};

export default memo(Sidebar);
